import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IEventState }          from 'Redux/Slices/Event/EventSlice';

export const findEventEmployeesRequest = (state: Draft<IEventState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  // Clear the previous event's assignment immediately, so a stale set can't be sent along
  // if the admin assigns an employee before this fetch for the newly opened event resolves.
  state.assignedEmployeeIds = [];
  state.updatedAt = Date.now();
};

export const findEventEmployeesSuccess = (state: Draft<IEventState>, { type, payload }: PayloadAction<{ userIds: string[] }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.assignedEmployeeIds = payload.userIds;
};

export const findEventEmployeesFailure = (state: Draft<IEventState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
